/**
 * PGC Artwork Inquiry — direct HubSpot Forms API v3 submission.
 * Ersetzt das gerenderte HubSpot-Formular im Inquiry-Modal.
 * Alle artwork_*-Felder werden EXPLIZIT übergeben — kein Hidden-Field-Renderer mehr.
 */
const PGC_HS_PORTAL = '7949537';
const PGC_HS_FORM = '2089c9fc-277c-4396-838e-eaf7a9067baa';
const PGC_HS_ENDPOINT =
  `https://api.hsforms.com/submissions/v3/integration/submit/${PGC_HS_PORTAL}/${PGC_HS_FORM}`;

function pgcGetCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : undefined;
}

/**
 * @param {Object} d
 * @param {string} d.email          Pflicht
 * @param {string} d.firstname     Pflicht
 * @param {string} d.lastname      Pflicht
 * @param {string} d.message       optional
 * @param {string} d.artwork_artist  Pflicht — ohne dieses Feld entsteht in
 *                                    HubSpot KEIN Deal (Make-Filter).
 * @param {string} d.artwork_title   Pflicht
 * @param {string} d.artwork_variant optional (Grösse/Edition)
 * @param {string} d.artwork_url     optional; Default = aktuelle Produkt-URL
 * @returns {Promise<Object>} HubSpot-Antwort (inlineMessage bei Erfolg)
 */
async function pgcSubmitInquiry(d) {
  // Guard AN DER QUELLE — nie stumm ohne Artist abschicken:
  const required = ['email', 'firstname', 'lastname', 'artwork_artist', 'artwork_title'];
  const missing = required.filter((k) => !d[k] || !String(d[k]).trim());
  if (missing.length) {
    throw new Error('PGC inquiry blocked — missing fields: ' + missing.join(', '));
  }

  const field = (name, value) => ({ objectTypeId: '0-1', name, value: String(value) });
  const fields = [
    field('email', d.email),
    field('firstname', d.firstname),
    field('lastname', d.lastname),
    field('artwork_artist', d.artwork_artist),
    field('artwork_title', d.artwork_title),
  ];
  if (d.message) fields.push(field('message', d.message));
  if (d.artwork_variant) fields.push(field('artwork_variant', d.artwork_variant));
  fields.push(field('artwork_url', d.artwork_url || window.location.href));

  const payload = {
    submittedAt: Date.now(),
    fields,
    context: {
      hutk: pgcGetCookie('hubspotutk'), // Analytics-Attribution, darf fehlen
      pageUri: window.location.href,
      pageName: document.title,
    },
  };

  const res = await fetch(PGC_HS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let detail = '';
    try { detail = JSON.stringify(await res.json()); } catch (_) {}
    throw new Error(`HubSpot submission failed (${res.status}): ${detail}`);
  }
  return res.json();
}

// Export für Theme-Bundler ODER global für inline-Snippets:
window.pgcSubmitInquiry = pgcSubmitInquiry;
